import React, { Component } from "react"
import { get } from "lodash"
import PropTypes from "prop-types"
import ReactTooltip from "react-tooltip"
import { Field, reduxForm } from "redux-form"
import { connect } from "react-redux"
import IconInfo from "material-ui/svg-icons/action/info"
import compose from "recompose/compose"
import { ValuesForm } from "../components"
import { TextField } from "redux-form-material-ui"
import Paper from "material-ui/Paper"
import { Card } from "material-ui/Card"
import { Flex, Box } from "rebass"
import { push as pushAction } from "react-router-redux"
import {
  Toolbar,
  translate,
  GET_ONE,
  UPDATE,
  showNotification as showNotificationAction,
} from "admin-on-rest"

import { ViewTitle, checkNumber } from "../components"
import { DivFormContainer, HeaderTitleEdit } from "./styled"
import { red500 } from "material-ui/styles/colors"

import { RestClient, RestApiShortUrl } from "../restClient"

import { agencyMarketerReceived as agencyMarketerReceivedAction } from "./redux"

const required = (value) => (value == null ? "Required" : undefined)
const email = (value) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? "Invalid email"
    : undefined

class EditDetailMarketer extends Component {
  handleSubmitWithRedirect = (redirect = this.props.redirect) =>
    this.props.handleSubmit((values) => {
      // console.log(values);
      // this.save(values);
      this.getSlug(values)
    })
  constructor(props) {
    super(props)
    this.state = {
      marketer: {},
    }
    if (props.match.params.agencyid) {
      this.getAgencyMarketer(props.match.params)
    }
  }

  getAgencyMarketer(params) {
    RestClient(GET_ONE, `agencyMarketers/${params.id}`, { id: params.agencyid })
      .then((items) => {
        if (items && items.data) {
          // console.log(items.data)
          this.setState({ marketer: items.data })
          this.props.agencyMarketerReceived(items.data)
        } else {
          this.props.showNotification("Please try to refresh again", "warning")
        }
      })
      .catch((e) => {
        this.props.showNotification("Please try to refresh again", "warning")
      })
  }
  getSlug = (values) => {
    if (get(values, "nickname", "") === "") {
      this.props.showNotification("Nickname Can not empty", "warning")
    } else {
      RestApiShortUrl(values.nickname)
        .then((response) => {
          if (response.status >= 400) {
            this.props.showNotification("Bad response from server", "warning")

            throw new Error("Bad response from server")
          }
          return response.json()
        })
        .then((data) => {
          if (!data.exists) {
            this.save(values)
          } else {
            const { marketer } = this.state
            if (
              get(marketer, "nickname", "") === get(values, "nickname", "") &&
              get(values, "nickname", "") !== ""
            ) {
              this.save(values)
            } else {
              this.props.showNotification(
                "The Nickname already have",
                "warning"
              )
            }
          }
        })
        .catch((e) => {
          this.props.showNotification("Please try again", "warning")
          console.error(e)
        })
    }
  }
  handleChange = (value) => {
    this.setState({ value })
  }
  save(values) {
    const url = this.props.match.url
    RestClient(UPDATE, `agencyMarketers/${this.props.match.params.id}`, {
      data: values,
    })
      .then((items) => {
        if (items && items.data) {
          const paramsUrl = url.replace(
            `/${this.props.match.params.agencyid}`,
            ""
          )
          this.props.showNotification("Element Updated")
          this.props.push(paramsUrl)
        }
      })
      .catch((e) => {
        console.log(e)
        this.props.showNotification("Please try again", "warning")
      })
  }

  renderInfoDetail() {
    return (
      <Paper zDepth={1}>
        <Box w={[1]} p={[1]} pb={[0]}>
          Details
        </Box>
        <Flex w={[1]} p={[1]} wrap direction={["row"]}>
          <Box w={[1, 1 / 2]} p={[1]}>
            <Field
              name="first_name"
              component={TextField}
              hintText="First name"
              floatingLabelText="First name"
              validate={required}
              fullWidth={true}
              ref="first_name"
              withRef
            />
          </Box>
          <Box w={[1, 1 / 2]} p={[1]}>
            <Field
              name="last_name"
              component={TextField}
              hintText="Last name"
              floatingLabelText="Last name"
              validate={required}
              fullWidth={true}
              ref="last_name"
              withRef
            />
          </Box>
          <Box w={[1, 1 / 2]} p={[1]}>
            <Field
              name="nickname"
              component={TextField}
              hintText="Nickname"
              floatingLabelText="Nickname"
              validate={required}
              fullWidth={true}
              ref="nickname"
              withRef
            />
          </Box>
          <Box w={[1, 1 / 2]} p={[1]}>
            <Field
              name="email"
              component={TextField}
              type={"email"}
              hintText="Google mail"
              floatingLabelText="Google mail"
              validate={[required, email]}
              fullWidth={true}
              ref="email"
              withRef
            />
          </Box>
          <Box w={[1, 1 / 2]} p={[1]}>
            <Field
              name="mobile"
              component={TextField}
              hintText="Mobile"
              floatingLabelText="Mobile"
              validate={required}
              fullWidth={true}
              ref="mobile"
              withRef
            />
          </Box>
          <Flex w={[1, 1 / 2]} p={[1]} direction={["row"]} align={["flex-end"]}>
            <Field
              name="custom4.margin"
              component={TextField}
              hintText="Margin %"
              floatingLabelText="Margin %"
              validate={required}
              fullWidth={true}
              ref="custom4.margin"
              parse={(v) => checkNumber(v)}
              withRef
            />
            <span data-tip="" data-for="margintooltip">
              <IconInfo style={iconStyles} color={red500} />
            </span>
            <ReactTooltip
              id="margintooltip"
              type="error"
              aria-haspopup="true"
              place="top"
            >
              <span>Margin to be given to the agency </span>
            </ReactTooltip>
          </Flex>
        </Flex>
      </Paper>
    )
  }
  renderInfoSocial() {
    return (
      <Paper zDepth={1}>
        <Box w={[1]} p={[1]} pb={[0]}>
          Social
        </Box>
        <Flex w={[1]} p={[1]} wrap direction={["row"]}>
          <Box w={[1, 1 / 2]} p={[1]}>
            <Field
              name="social.instagram"
              component={TextField}
              hintText="Instagram"
              floatingLabelText="Instagram"
              fullWidth={true}
              ref="social.instagram"
              withRef
            />
          </Box>
          <Box w={[1, 1 / 2]} p={[1]}>
            <Field
              name="social.youtube"
              component={TextField}
              hintText="Youtube"
              floatingLabelText="Youtube"
              fullWidth={true}
              ref="social.youtube"
              withRef
            />
          </Box>
        </Flex>
      </Paper>
    )
  }

  render() {
    const { invalid, submitOnEnter, toolbar } = this.props
    return (
      <Card containerStyle={{ minHeight: 518 }}>
        <ViewTitle title={<HeaderTitleEdit {...this.props} />} />
        <form className="simple-form">
          <DivFormContainer w={[1]}>
            <Box w={[1]} py={[1]} px={[2]}>
              {this.renderInfoDetail()}
            </Box>
            <Box w={[1]} py={[1]} px={[2]}>
              {this.renderInfoSocial()}
            </Box>
          </DivFormContainer>
          {toolbar &&
            React.cloneElement(toolbar, {
              handleSubmitWithRedirect: this.handleSubmitWithRedirect,
              invalid,
              submitOnEnter,
            })}
          <ValuesForm isDebug={true} formName={"record-form"} />
        </form>
      </Card>
    )
  }
}

const iconStyles = {
  marginLeft: 16,
  width: 24,
  height: 24,
}

EditDetailMarketer.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  handleSubmit: PropTypes.func,
  invalid: PropTypes.bool,
  record: PropTypes.object,
  resource: PropTypes.string,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  save: PropTypes.func,
  submitOnEnter: PropTypes.bool,
  toolbar: PropTypes.element,
  validate: PropTypes.func,
  translate: PropTypes.func,
  agencyMarketerReceived: PropTypes.func,
  push: PropTypes.func,
  showNotification: PropTypes.func,
}

EditDetailMarketer.defaultProps = {
  submitOnEnter: false,
  toolbar: <Toolbar />,
  translate: translate,
  defaultValue: {
    agency_id: "",
    margin: 0,
  },
}
// const selector = formValueSelector("record-form");
const enhance = compose(
  connect(
    (state, props) => {
      const agency_id = props.match.params.id * 1

      const marketer = state.agencymarketer
        ? state.agencymarketer
        : {
            custom4: {
              agency_id: agency_id,
              margin: 0,
            },
          }
      return {
        initialValues: marketer,
        agency_id,
      }
    },
    {
      agencyMarketerReceived: agencyMarketerReceivedAction,
      showNotification: showNotificationAction,
      push: pushAction,
    }
  ),
  reduxForm({
    form: "record-form",
    enableReinitialize: true,
  })
)

export default enhance(EditDetailMarketer)
// export default EditDetailMarketer;



// WEBPACK FOOTER //
// ./src/agency/EditDetailMarketer.js